import React from "react";
import points_details from "../../../../../assets/svgs/points_details.svg";
import { imageContainerStyle as styles } from "../redeemRewards.tailwind";
import { useSelector } from "react-redux";

const PointsDetailSection = () => {
  // const LifetimePoints = 240;
  // const AvailablePoints = 240;
  const { userPointsAndRewards }= useSelector( state=> state.reward);
  

  return (
    <div className={styles.image_container} style={{ backgroundImage: `url(${points_details})` }}>
      <div className={styles.image_data}>
        <div className={styles.data_container}>
          <span className={`${styles.points}`}>{userPointsAndRewards?.userTotalEarnedPoints}</span>
          <span className={styles.points_heading}>Lifetime Points</span>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.data_container}>
          <span className={`${styles.points}`}>{userPointsAndRewards?.userTotalAvailablePoints}</span>
          <div className={styles.points_heading}>Available Points</div>
        </div>
      </div>
    </div>
  );
};

export default PointsDetailSection;
